import { FileText, Package, Truck, Users } from "lucide-react"
import { useSearchParams } from "react-router"

import { AgenciaAsignaciones } from "@/componentes/transporte/AgenciaAsignaciones"
import { AgenciaRecibos } from "@/componentes/transporte/AgenciaRecibos"
import { Intermediarios } from "@/componentes/transporte/Intermediarios"
import { type Pestana, Pestanas } from "@/componentes/ui/Pestanas"

type Vista = "recibos" | "asignaciones" | "intermediarios"

const PESTANAS: Pestana<Vista>[] = [
  { valor: "recibos", etiqueta: "Recibos de flete", icono: FileText },
  { valor: "asignaciones", etiqueta: "Cargas asignadas", icono: Package },
  { valor: "intermediarios", etiqueta: "Intermediarios", icono: Users },
]

/**
 * Fletes y transporte (25/10): lo que los intermediarios cargan en el portal de transporte,
 * visto desde la agencia. Se LEE y se marca lo recibido en papel; el catálogo de ellos no
 * se edita desde aquí. Ver `api/v1/agencia_transporte.py`.
 */
export function Fletes() {
  const [parametros, setParametros] = useSearchParams()
  const pedida = parametros.get("vista")
  const vista: Vista = pedida === "intermediarios" || pedida === "asignaciones" ? pedida : "recibos"
  return (
    <div className="space-y-4">
      <header>
        <h1 className="flex items-center gap-2 text-xl font-semibold">
          <Truck size={20} aria-hidden={true} /> Fletes y transporte
        </h1>
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          Los recibos que emiten los intermediarios en el portal de transporte, con sus soportes.
        </p>
      </header>
      <Pestanas
        pestanas={PESTANAS}
        activa={vista}
        onCambiar={(v) => setParametros(v === "recibos" ? {} : { vista: v }, { replace: true })}
        etiqueta="Vistas de fletes"
        idPanel="panel-fletes"
        prefijoId="pestana-fletes"
      />
      <section id="panel-fletes" role="tabpanel" aria-labelledby={`pestana-fletes-${vista}`}>
        {vista === "recibos" ? (
          <AgenciaRecibos />
        ) : vista === "asignaciones" ? (
          <AgenciaAsignaciones />
        ) : (
          <Intermediarios />
        )}
      </section>
    </div>
  )
}
